export default __webpack_public_path__ + "static/media/ready-to-go.e9856eb8.svg";